const BASE_CONFIG = {
  titleLabel: "Nội dung phiếu",
  titlePlaceholder: "Nhập nội dung cần ghi nhận",
  partyLabel: "Người nhận / Nhà cung cấp",
  partyPlaceholder: "Nhập người nhận hoặc nhà cung cấp",
  addressLabel: "Địa chỉ / Thông tin liên hệ",
  addressPlaceholder: "Nhập địa chỉ, số điện thoại hoặc mã tham chiếu",
  amountLabel: "Số tiền",
  amountPlaceholder: "0",
  noteLabel: "Ghi chú",
  notePlaceholder: "Nhập ghi chú nếu có",
};

const FORM_CONFIGS = {
  income: {
    titleLabel: "Nội dung thu",
    titlePlaceholder: "Ví dụ: Thu tiền bán hàng, thu công nợ",
    partyLabel: "Người nộp / Nguồn thu",
    partyPlaceholder: "Nhập người nộp hoặc nguồn thu",
    addressLabel: "Thông tin người nộp",
    addressPlaceholder: "Số điện thoại, địa chỉ hoặc mã khách hàng",
    amountLabel: "Số tiền thu",
    notePlaceholder: "Nội dung thanh toán hoặc chứng từ liên quan",
  },
  outcome: {
    titleLabel: "Nội dung chi",
    titlePlaceholder: "Nhập nội dung khoản chi",
    amountLabel: "Số tiền chi",
  },
  electricity: {
    defaultTime: "now",
    titleLabel: "Nội dung tiền điện",
    titlePlaceholder: "Ví dụ: Tiền điện tháng 7/2026",
    partyLabel: "Nhà cung cấp điện",
    partyPlaceholder: "Chọn hoặc nhập đơn vị điện lực",
    addressLabel: "Mã khách hàng / Điểm sử dụng điện",
    addressPlaceholder: "Nhập mã khách hàng hoặc địa chỉ sử dụng điện",
    amountLabel: "Số tiền điện",
    noteLabel: "Kỳ hóa đơn / Ghi chú",
    notePlaceholder: "Nhập kỳ hóa đơn, mã hóa đơn hoặc ghi chú",
    providerOptions: [
      "Tổng công ty Điện lực miền Bắc (EVNNPC)",
      "Tổng công ty Điện lực miền Trung (EVNCPC)",
      "Tổng công ty Điện lực miền Nam (EVNSPC)",
      "Tổng công ty Điện lực TP Hà Nội (EVNHANOI)",
      "Tổng công ty Điện lực TP Hồ Chí Minh (EVNHCMC)",
    ],
  },
  internet: {
    defaultTime: "now",
    titleLabel: "Nội dung cước Internet",
    titlePlaceholder: "Ví dụ: Cước Internet tháng 7/2026",
    partyLabel: "Nhà cung cấp Internet",
    partyPlaceholder: "Chọn hoặc nhập nhà mạng",
    addressLabel: "Mã hợp đồng / Địa chỉ lắp đặt",
    addressPlaceholder: "Nhập mã hợp đồng hoặc địa chỉ lắp đặt",
    amountLabel: "Cước thanh toán",
    noteLabel: "Gói cước / Ghi chú",
    notePlaceholder: "Nhập tên gói cước, kỳ thanh toán hoặc ghi chú",
    providerOptions: [
      "Viettel Telecom",
      "VNPT",
      "FPT Telecom",
      "CMC Telecom",
      "SCTV",
      "NetNam",
      "SPT",
    ],
  },
  water: {
    defaultTime: "now",
    titleLabel: "Nội dung tiền nước",
    titlePlaceholder: "Ví dụ: Tiền nước tháng 7/2026",
    partyLabel: "Nhà cung cấp nước",
    partyPlaceholder: "Chọn hoặc nhập công ty cấp nước địa phương",
    addressLabel: "Mã khách hàng / Điểm sử dụng nước",
    addressPlaceholder: "Nhập mã khách hàng hoặc địa chỉ sử dụng nước",
    amountLabel: "Số tiền nước",
    noteLabel: "Kỳ hóa đơn / Ghi chú",
    notePlaceholder: "Nhập kỳ hóa đơn, chỉ số hoặc ghi chú",
    providerOptions: [
      "Công ty Nước sạch Hà Nội (HAWACOM)",
      "Tổng công ty Cấp nước Sài Gòn (SAWACO)",
      "Công ty Cổ phần Cấp nước Đà Nẵng (DAWACO)",
      "Công ty Cổ phần Nước - Môi trường Bình Dương (BIWASE)",
      "Công ty Cổ phần Cấp nước Hải Phòng",
    ],
  },
  rent: {
    defaultTime: "now",
    titleLabel: "Nội dung thuê mặt bằng",
    titlePlaceholder: "Ví dụ: Tiền thuê mặt bằng tháng 7/2026",
    partyLabel: "Chủ nhà / Đơn vị cho thuê",
    partyPlaceholder: "Nhập chủ nhà hoặc đơn vị cho thuê",
    addressLabel: "Địa chỉ mặt bằng",
    addressPlaceholder: "Nhập địa chỉ mặt bằng thanh toán",
    amountLabel: "Tiền thuê",
    noteLabel: "Kỳ thuê / Ghi chú",
    notePlaceholder: "Nhập kỳ thuê, số hợp đồng hoặc ghi chú",
  },
  marketing: {
    titleLabel: "Nội dung Marketing",
    titlePlaceholder: "Ví dụ: Quảng cáo Facebook tháng 7/2026",
    partyLabel: "Kênh / Nhà cung cấp Marketing",
    partyPlaceholder: "Chọn hoặc nhập kênh quảng cáo, agency",
    addressLabel: "Tài khoản / Mã chiến dịch",
    addressPlaceholder: "Nhập tài khoản quảng cáo hoặc mã chiến dịch",
    amountLabel: "Ngân sách chi",
    noteLabel: "Chiến dịch / Ghi chú",
    notePlaceholder: "Nhập tên chiến dịch, thời gian chạy hoặc ghi chú",
    providerOptions: [
      "Meta Ads (Facebook / Instagram)",
      "Google Ads",
      "TikTok Ads",
      "Zalo Ads",
      "Cốc Cốc Ads",
    ],
  },
  other: {
    titleLabel: "Tiêu đề khoản chi",
    titlePlaceholder: "Nhập tiêu đề khoản chi",
    partyLabel: "Người nhận / Nhà cung cấp",
    partyPlaceholder: "Nhập người nhận hoặc đơn vị cung cấp",
    addressLabel: "Thông tin liên hệ / Tham chiếu",
    amountLabel: "Số tiền chi",
  },
};

export const getCashFlowCreateFormConfig = (templateKey, type) => ({
  ...BASE_CONFIG,
  ...(type === "income" ? FORM_CONFIGS.income : FORM_CONFIGS.outcome),
  ...(FORM_CONFIGS[templateKey] || {}),
});

export const getCashFlowProviderOptions = (templateKey, type) =>
  (getCashFlowCreateFormConfig(templateKey, type).providerOptions || []).map((provider) => ({
    label: provider,
    value: provider,
  }));
